import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import InfoBadge from '../../Components/Filter/Components/Products/Components/Badges/InfoBadge';

const productBadgesContainers = document.querySelectorAll('.js-product-badges') as NodeListOf<HTMLElement>;

export default function ProductBadgesIntegrations() {
    return (
        <>
            {[...productBadgesContainers].map((productBadgesContainer, index) => {
                const isDiscounted = productBadgesContainer.dataset.discount === 'true';
                const isNew = productBadgesContainer.dataset.new === 'true';
                const savingPercent = productBadgesContainer.dataset.savingPercent
                    ? parseInt(productBadgesContainer.dataset.savingPercent)
                    : null;

                return (
                    <Fragment key={index}>
                        {ReactDOM.createPortal(
                            <InfoBadge isDiscounted={isDiscounted} isNew={isNew} savingPercent={savingPercent} />,
                            productBadgesContainer,
                        )}
                    </Fragment>
                );
            })}
        </>
    );
}
